import {
  ADD_PORTLET,
  SET_MENU,
  SET_SETTINGS,
  SET_MESSAGES,
  SET_DOCUMENT_TYPES,
  SET_DOCUMENT_CATEGORIES,
  SET_TAXONOMY_TREE,
  SET_TAXONOMY_SUGGESTIONS,
  SET_TAXONOMY_NODELOOKUP,
  SET_USER,
  SET_API_LOCATION,
  ADD_MESSAGE,
  UPDATE_MESSAGE,
  SET_SELECTION_OPTIONS,
  CHANGE_SETTING,
  CHANGE_LANGUAGE,
  SET_NOTIFICATIONS,
  SET_APPLICATION_PROPERTIES,
  SET_LICENCE,
  SET_ALL_LICENCES,
  SET_ISMOBILE,
  SET_GLOBAL_ALERT,
  SET_RUNNING_JOBS,
} from "./actionTypes";

export const setGlobalAlert = (globalAlert)=>({
  type: SET_GLOBAL_ALERT,
  globalAlert,
})

export const setLicence = (licence) => ({
  type: SET_LICENCE,
  licence,
});

export const setIsMobile = (isMobile) => ({
  type: SET_ISMOBILE,
  isMobile,
});

export const setNotifications = (notifications) => ({
  type: SET_NOTIFICATIONS,
  notifications,
});

export const setUser = (user) => ({
  type: SET_USER,
  currentUser: user,
});

export const changeSetting = (settings) => ({
  type: CHANGE_SETTING,
  settings: settings,
});

export const setSelectionOptions = (options) => ({
  type: SET_SELECTION_OPTIONS,
  options: options,
});

export const setDocumentTypes = (types) => ({
  type: SET_DOCUMENT_TYPES,
  documentTypes: types,
});

export const setRunningJobs = (jobs) => ({
  type: SET_RUNNING_JOBS,
  runningJobs: jobs,
});

export const setDocumentCategories = (categories) => ({
  type: SET_DOCUMENT_CATEGORIES,
  documentCategories: categories,
});

export const setTaxonomyTree = (taxonomy) => ({
  type: SET_TAXONOMY_TREE,
  taxonomyTree: taxonomy,
});

export const setTaxonomySuggestions = (suggestions) => ({
  type: SET_TAXONOMY_SUGGESTIONS,
  taxonomySuggestions: suggestions,
});

export const setTaxonomyNodeLookup = (lookup) => ({
  type: SET_TAXONOMY_NODELOOKUP,
  taxonomyNodeLookup: lookup,
});

export const setApplicationProperties = (properties) => ({
  type: SET_APPLICATION_PROPERTIES,
  properties,
});

export const setSettings = (settings) => ({
  type: SET_SETTINGS,
  settings: settings,
});

export const setMenu = (menu, number) => ({
  type: SET_MENU,
  menu: menu,
  number: number,
});

export const addPortlet = (menu) => ({
  type: ADD_PORTLET,
  menu: menu,
});

export const setApiLocation = (location) => ({
  type: SET_API_LOCATION,
  location: location,
});

export const addMessage = (message) => ({
  type: ADD_MESSAGE,
  message: message,
});

export const setMessages = (messages) => ({
  type: SET_MESSAGES,
  messages: messages,
});

export const updateMessage = (message) => ({
  type: UPDATE_MESSAGE,
  message: message,
});

export const changeLanguage = (language) => ({
  type: CHANGE_LANGUAGE,
  language,
});
